module.exports = __webpack_public_path__ + "img/icon-budget.69364904.svg";